// react
// dependencies
import { List, Map } from "immutable";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

// constants
// components
import Icon from "../../../../components/Icon";
import TextInput from "../../../../components/Inputs/TextInput";
import Spinner from "../../../../components/Spinner/ComponentLoader";

import PageCurtain from "../../../../containers/PageCurtain";

import { SearchGroups } from "../../../../actions/departments.actions";
import { StateChange } from "../../../../actions/page.actions";
// actions
import { AddGroup } from "../../actions";

// styles
import css from "./GroupSearching.module.scss";

class GroupSearching extends React.Component {
	/*
	 */

	static propTypes = {
		showIsAdding: PropTypes.bool.isRequired,
		showGroupCurtain: PropTypes.bool.isRequired,
		changeState: PropTypes.func.isRequired,
		searchGroups: PropTypes.func.isRequired,
		addGroupToSelection: PropTypes.func.isRequired,
		filters: PropTypes.instanceOf(Map),
		exclusionList: PropTypes.instanceOf(List),
		groupQueries: PropTypes.instanceOf(Map).isRequired,
		groupMap: PropTypes.instanceOf(Map).isRequired,
		allowAllEmployees: PropTypes.bool,
	};

	static defaultProps = {
		exclusionList: List(),
		filters: Map(),
		allowAllEmployees: true,
	};

	state = {
		query: "",
		hasTypedSomething: true,
		hasMounted: false,
	};

	componentDidMount() {
		this.props.searchGroups("");
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.showGroupCurtain && this.props.showGroupCurtain && !this.state.hasMounted) {
			setTimeout(this.onFirstMount, 50);
		}
	}

	onFirstMount = () => {
		this.setState({ hasMounted: true });
	};

	handleSearch = (value) => {
		this.setState({ query: value, hasTypedSomething: true }, () => {
			this.props.searchGroups(value);
		});
	};

	handleGroupClick = (groupId) => {
		this.setState({ query: "" }, () => {
			this.props.addGroupToSelection(groupId, this.props.exclusionList, this.props.filters);
		});
	};

	handleCloseCurtain = () => {
		this.props.changeState("showGroupCurtain", false);
	};

	render() {
		const { showGroupCurtain, groupQueries, groupMap, allowAllEmployees } = this.props;

		if (!showGroupCurtain) {
			return <div />;
		}

		const queryResponse = groupQueries.get(this.state.query, List());

		return (
			<div>
				<PageCurtain onClose={this.handleCloseCurtain}>
					<div>
						<section
							style={{
								left: this.state.hasMounted ? 0 : "-100%",
							}}
							className="group-search-curtain"
						>
							<section className="content-wrapper" style={{ width: 600 }}>
								<div className="input-container">
									<div className="search-label">
										<Icon type="material" name="group" size={30} />
										<div className="label">Add a Group to the Selection</div>
										{this.props.showIsAdding ? (
											<div className={css.spinnerContainer}>
												<Spinner showCurtain={true} borderWidth={3} centered={true} size={30} />
											</div>
										) : null}
									</div>
									<TextInput
										placeholder="Search"
										onChange={this.handleSearch}
										value={this.state.query}
									/>
								</div>

								<div className="group-results-container">
									{!this.state.hasTypedSomething ? (
										<div
											style={{
												fontSize: 18,
												fontStyle: "italic",
												color: "#666",
											}}
										>
											Search and add users from a group.
										</div>
									) : (
										""
									)}

									{this.state.hasTypedSomething && allowAllEmployees ? (
										<div
											key="all_users"
											onClick={() => this.handleGroupClick("all_users")}
											className="group-row"
										>
											<div className="group-name">All Employees</div>
										</div>
									) : (
										""
									)}

									{groupMap.size > 0 &&
										queryResponse.map((groupId) => {
											const group = groupMap.get(groupId);
											return (
												<div
													key={groupId}
													onClick={() => this.handleGroupClick(groupId)}
													className="group-row"
												>
													<div className="group-name">
														{group.get("name")}{" "}
														<span
															style={{
																color: "grey",
															}}
														>
															({group.get("numUsers")} user
															{group.get("numUsers") === 1 ? "" : "s"})
														</span>
													</div>
												</div>
											);
										})}
								</div>
							</section>
						</section>
					</div>
				</PageCurtain>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	groupQueries: state.departments.getIn(["queries"]),
	groupMap: state.departments.getIn(["departmentMap"]),
	showGroupCurtain: state.page.getIn([ownProps.storeName, "showGroupCurtain"], false),
	showIsAdding: state.page.getIn([ownProps.storeName, "showIsAdding"], false),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	searchGroups: (query) => dispatch(SearchGroups(query)),
	changeState: (keyPath, value) => dispatch(StateChange(ownProps.storeName, keyPath, value)),
	addGroupToSelection: (groupId, exclusionList, filters) =>
		dispatch(AddGroup(ownProps.selectionObjectId, [groupId], exclusionList, filters, ownProps.storeName)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GroupSearching);
